import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

/**
 * 👥 Clientes Frecuentes
 *
 * Backend esperado: branchId, dateFrom, dateTo
 */
export const frequentCustomerReportFilters: UniversalFilterConfig[] = [
  {
    name: "branchId",
    label: "Sucursal",
    type: "select",
    iconKey: "branch",
  },
  {
    name: "dateFrom",
    label: "Fecha Desde",
    type: "date",
    iconKey: "calendar",
  },
  {
    name: "dateTo",
    label: "Fecha Hasta",
    type: "date",
    iconKey: "calendar",
  },
];
